import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#alignment" }),
  /*#__PURE__*/_createTextVNode(" Alignment ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Depending on your design, there are several different ways to align your label element. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Left")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Right")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Top")
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { style: {"margin":"20px"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_radio_button = _resolveComponent("el-radio-button")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_radio_group, {
        modelValue: _ctx.labelPosition,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.labelPosition = $event)),
        size: "small"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_radio_button, { label: "left" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio_button, { label: "right" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_radio_button, { label: "top" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _hoisted_8,
      _createVNode(_component_el_form, {
        "label-position": _ctx.labelPosition,
        "label-width": "100px",
        model: _ctx.formLabelAlign
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "Name" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formLabelAlign.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formLabelAlign.name = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "Activity zone" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formLabelAlign.region,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formLabelAlign.region = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "Activity form" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formLabelAlign.type,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formLabelAlign.type = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label-position", "model"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code3), 1)
        ]),
        _: 1
      })
    ])
  ]))
}